import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppComponent} from './app.component';
import {HeaderComponent} from './header/header.component';
import {NavigationComponent} from './navigation/navigation.component';
import {ExtendedModule, FlexModule} from '@angular/flex-layout';
import {HomeComponent} from './routes/home/home.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ContextLeftComponent} from './context-left/context-left.component';
import {FooterComponent} from './footer/footer.component';
import {SpeiseplanComponent} from './routes/speiseplan/speiseplan.component';
import {ContactComponent} from './routes/contact/contact.component';
import {QualityComponent} from './routes/quality/quality.component';
import {HeaderContextComponent} from './header-context/header-context.component';
import {HttpClientModule} from '@angular/common/http';
import {BreakfastComponent} from './routes/breakfast/breakfast.component';
import {BdmNewsComponent} from './routes/home/bdm-news/bdm-news.component';
import {BdmNewsOverviewComponent} from './routes/home/bdm-news/bdm-news-overview/bdm-news-overview.component';
import {FamilyStoryComponent} from './shared/family-story/family-story.component';
import {RevealDirective} from './shared/reveal.directive';

import {AppRoutingModule} from './app-routing.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';

@NgModule({
    declarations: [
    AppComponent,
    HeaderComponent,
    NavigationComponent,
    HomeComponent,
    ContextLeftComponent,
    FooterComponent,
    SpeiseplanComponent,
    ContactComponent,
    QualityComponent,
    HeaderContextComponent,
    BreakfastComponent,
    BdmNewsComponent,
    BdmNewsOverviewComponent,
    FamilyStoryComponent,
    RevealDirective
    ],
    imports: [
    BrowserModule.withServerTransition({appId: 'serverApp'}),
    AppRoutingModule,
    FlexModule,
    ExtendedModule,
    FontAwesomeModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatMenuModule,
    MatButtonModule
    ],
    bootstrap: [AppComponent],
    })
export class AppModule {
}
